

































































































































































































import { Component, Vue } from 'vue-property-decorator';
@Component({
})
export default class Faq extends Vue {
  /* eslint-disable no-console */
  private idClubPetco: any = this.$store.getters.getClubPetcoEncuesta;
  private nombreCampania: string = '';
  private frasesRefuerzo: any = [];
  private frasePosicionamiento: any = '';
  private sugerenciaAdicional: string = '';
  private snackbar: any = {
    active: false,
    text: '',
    type: 'error'
  }

  private get muestraPregunta() {
    return this.$store.getters.getClubPetcoEncuesta.length === 5;
  }


  private definido(val: any) {
    return val !== undefined && val !== null && val !== ''; 
  }


  private async enviarRespuestas() {
    if (!this.definido(!this.nombreCampania) || 
      (this.muestraPregunta && !this.definido(!this.frasePosicionamiento)) || 
      !Array.isArray(this.frasesRefuerzo) || 
      this.frasesRefuerzo.length === 0) {
        this.snackbar = { active: true, text: 'Faltan campos obligatorios, recuerda contestar todas las preguntas', type: 'error'};
        return;
    }

    if (this.frasesRefuerzo.length !== 5) {
      this.snackbar = { active: true, text: 'Por favor, elige 5 frases en la pregunta 2', type: 'error'};
      return;
    }

    let resultado = await this.$store.dispatch('GuardaEncuesta', {
      cliente: this.idClubPetco,
      respuestas: [
        {pregunta: '1', respuesta: this.nombreCampania},
        {pregunta: '2', respuesta: this.frasesRefuerzo.toString()},
        {pregunta: '3', respuesta: this.frasePosicionamiento},
        {pregunta: '4', respuesta: this.sugerenciaAdicional}
      ]
    });

    if ([200, 201].includes(resultado.replyCode)) {
      this.snackbar = { active: true, text: resultado.replyText, type: 'success'};
    } else {
      this.snackbar = { active: true, text: resultado.replyText, type: 'error' };
    }
  }
}   
